import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createAtlassianGatewayClient, createTeamCentralClient, createWorklensClient, createApolloClient as newApolloClient } from '@atlassian/ptc-graphql-client';
import { DEV, getConfig } from '@atlassian/teams-common/context-config';
import { withDefaultExponentialBackoff } from '../utils/http';
var customFetch = withDefaultExponentialBackoff(fetch);

/*************************************************/
// a common Apollo Client
var cachedApolloClient;
export var getApolloClient = function getApolloClient(customConfig) {
  if (cachedApolloClient) {
    return cachedApolloClient;
  }
  var apolloClient = createApolloClient(customConfig);
  // don't cache apolloClient when cloudId is empty string
  if (customConfig !== null && customConfig !== void 0 && customConfig.getCloudId && customConfig !== null && customConfig !== void 0 && customConfig.getCloudId()) {
    cachedApolloClient = apolloClient;
  }
  return apolloClient;
};
export var createApolloClient = function createApolloClient(customConfig) {
  return newApolloClient(_objectSpread({
    connectToDevTools: !!DEV,
    url: {
      stargateRoot: getConfig().stargateRoot,
      collaborationGraph: getConfig().collaborationGraph
    },
    customFetch: customFetch
  }, customConfig));
};

/*************************************************/
// Worklens client
var cachedWorklensClient;
export var getWorklensClient = function getWorklensClient() {
  if (cachedWorklensClient) {
    return cachedWorklensClient;
  }
  cachedWorklensClient = createWorklensClient({
    url: {
      stargateRoot: getConfig().stargateRoot
    },
    customFetch: customFetch
  });
  return cachedWorklensClient;
};

/*************************************************/
// GraphQL Gateway client
var cachedGatewayClient;
export var getGatewayClient = function getGatewayClient() {
  if (cachedGatewayClient) {
    return cachedGatewayClient;
  }
  cachedGatewayClient = createAtlassianGatewayClient({
    url: {
      stargateRoot: getConfig().stargateRoot
    },
    customFetch: customFetch
  });
  return cachedGatewayClient;
};

/*************************************************/
// GraphQL Team Central client
var cachedTeamCentralClients = new Map();
export var getTeamCentralClient = function getTeamCentralClient(cloudId) {
  var maybeCachedTeamCentralClient = cachedTeamCentralClients.get(cloudId);
  if (maybeCachedTeamCentralClient) {
    return maybeCachedTeamCentralClient;
  }
  var teamCentralClient = createTeamCentralClient({
    url: {
      stargateRoot: getConfig().stargateRoot
    },
    customFetch: customFetch,
    getCloudId: function getCloudId() {
      return cloudId;
    }
  });
  cachedTeamCentralClients.set(cloudId, teamCentralClient);
  return teamCentralClient;
};